export const settingRoutes = {
	settingsIndex: '/store'
} as const
